import { useEffect } from 'react';

import { useCurrentWorkspaceId, useFreestyleToolsActions, useNotificationActions } from 'src/store';
import { captureMessage } from 'src/utils/lib/sentry';

export const usePreloadFreestyleTools = () => {
  const notificationActions = useNotificationActions();
  const freestyleToolsActions = useFreestyleToolsActions();
  const currentWorkspaceId = useCurrentWorkspaceId();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await freestyleToolsActions.queryFreestyleTools(currentWorkspaceId);
      } catch (error) {
        notificationActions.displayWarning('Error while getting freestyle tools');

        captureMessage('Error while getting freestyle tools', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'usePreloadFreestyleTools',
          },
        });
      }
    };

    // We should not load data if we are still loading initial stores data
    if (!currentWorkspaceId) {
      return;
    }

    fetchData();
  }, [currentWorkspaceId, freestyleToolsActions, notificationActions]);
};
